import React, { useState } from 'react';
import { Modal } from '../../../../shared/ui/Modal';
import {
  PrimaryButton,
  SecondaryButton,
  Select,
} from '../../../../shared/ui/Inputs';

type Division = '40' | '90';

type ChangePatientDivisionModalProps = {
  patientName: string;
  initialDivision: Division;
  onClose: () => void;
  onSave: (division: Division) => void;
};

export const ChangePatientDivisionModal: React.FC<
  ChangePatientDivisionModalProps
> = ({ patientName, initialDivision, onClose, onSave }) => {
  const [division, setDivision] = useState<Division>(initialDivision);

  return (
    <Modal
      open
      handleClose={onClose}
      width="420px"
      maxWidth="90vw"
      boxSizing="border-box"
      role="dialog"
      aria-modal="true"
      aria-labelledby="patient-division-title"
    >
      <h2 id="patient-division-title">Alterar divisão</h2>
      <p style={{ overflowWrap: 'anywhere' }}>
        Paciente: <strong>{patientName}</strong>
      </p>
      <label
        htmlFor="patient-division"
        style={{ display: 'block', marginBottom: '8px' }}
      >
        Divisão
      </label>
      <Select
        id="patient-division"
        style={{ width: '100%' }}
        value={division}
        onChange={(event) =>
          setDivision(event.target.value === '90' ? '90' : '40')
        }
      >
        <option value="40">40</option>
        <option value="90">90</option>
      </Select>
      <div
        style={{
          display: 'flex',
          justifyContent: 'flex-end',
          gap: '12px',
          marginTop: '24px',
        }}
      >
        <SecondaryButton onClick={onClose}>Cancelar</SecondaryButton>
        <PrimaryButton onClick={() => onSave(division)}>Salvar</PrimaryButton>
      </div>
    </Modal>
  );
};
